export function createTimeAxis(fCutOff) {
  /*pointsInStepResponse sets the number of points in the graph  It is a compromise between speed and accuracy.   
    jqplot in takes about 300 ms to plot 512 points in firefox in Jan 2013.  However smaller numbers of points start 
    to show choppiness in plots with lots of ripple like bandpass*/
  var pointsInStepResponse = 512;

  var timeConstant = 1 / (2 * Math.PI * fCutOff);

  var t50 = timeConstant * 25;

  var maxXaxis = t50.toPrecision(2); // rounding off to two significant digits

  var stepSize = maxXaxis / pointsInStepResponse;

  var result = [];
  for (var k = 0; k < pointsInStepResponse; k++) {
    result[k] = k * stepSize;
  }

  return result;
}
